import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-264e32bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "icon is-medium clickAble right" }
const _hoisted_3 = { class: "panel-block" }
const _hoisted_4 = {
  key: 0,
  class: "flex-cont"
}
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "checkbox" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "checkbox" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "control" }
const _hoisted_11 = { class: "checkbox" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "control" }
const _hoisted_14 = { for: "text-size" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "control" }
const _hoisted_18 = { class: "checkbox" }
const _hoisted_19 = { class: "control" }
const _hoisted_20 = { class: "checkbox" }
const _hoisted_21 = { class: "control" }
const _hoisted_22 = { class: "checkbox" }
const _hoisted_23 = { class: "control" }
const _hoisted_24 = { class: "icon" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "panel-heading",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isOpen = !_ctx.isOpen), ["stop"]))
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t("viewsettings")), 1),
      _createElementVNode("span", _hoisted_2, [
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: "chevron-up"
            }))
          : (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: "chevron-down",
              size: "1x"
            }))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.alteriNames) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.alteriNames]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("namesofcontactson")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showAge) = $event)),
                    disabled: !_ctx.alteriNames
                  }, null, 8, _hoisted_9), [
                    [_vModelCheckbox, _ctx.showAge]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("ageofcontactson")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showRole) = $event)),
                    disabled: !_ctx.alteriNames
                  }, null, 8, _hoisted_12), [
                    [_vModelCheckbox, _ctx.showRole]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("roleofcontactson")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("changesize")), 1),
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "range",
                  id: "text-size",
                  min: "2",
                  max: "13",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.textSize) = $event)),
                  disabled: !_ctx.alteriNames
                }, null, 8, _hoisted_16), [
                  [_vModelText, _ctx.textSize]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.horizons) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.horizons]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("horizonson")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.connections) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.connections]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("connectionson")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emoji) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.emoji]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("emojion")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "button",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePseudonyms && _ctx.togglePseudonyms(...args)), ["stop"]))
                }, [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_font_awesome_icon, { icon: "user-secret" })
                  ]),
                  (_ctx.pseudonyms)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.t("anonymiseoff")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.t("anonymiseon")), 1))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}